import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./HeaderDashboard";
import SideNav from "./SideNavbar";
import Footer from "./FooterDashboard";

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className={`gi-dashboard-shell ${isCollapsed ? "gi-collapsed" : ""}`} id="top">
      <Header
        onMenuClick={() => setSidebarOpen(v => !v)}
        isCollapsed={isCollapsed}
        onToggleCollapse={() => setIsCollapsed(v => !v)}
      />
      <div className="gi-dashboard-body">
        <SideNav isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} isCollapsed={isCollapsed} />
        <main className="gi-dashboard-content">
          <div className="gi-dashboard-page"><Outlet /></div>
          <Footer />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;